"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_voicemail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "5fe2cae3-fd22-4198-bbcf-7655dbb920ca",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "voicemail-hi"), /*#__PURE__*/React.createElement("g", {
    id: "8834dda7-9653-43de-a93d-9b78905bf7f5",
    "data-name": "3d50f17c-234f-4699-b3af-76e1347b13a3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4ae69a44-8c3c-4934-a2a9-eda0519b5755",
    "data-name": "36ae4878-4ff4-4d4c-87fa-459c4c1c8dcf"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5bd9bd7d-f990-4b97-b2ed-e034a5ff7440",
    "data-name": "c8eba312-18a9-4286-a10b-eac1e94d8dab"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d4b2a3ca-fd38-4436-a4b8-4123b078c003",
    "data-name": "c789b18c-1480-4dba-8a35-8cf8ffaf76fd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8e208fff-ab03-4f47-bed8-3d022db87644",
    "data-name": "9361381f-adca-4fcf-95c7-50f5bc7997d1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9261aa76-b048-412b-80b5-3548c6f2f7b4",
    "data-name": "a1b5e78a-be1b-4787-9d88-128674dc2509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,16.23h0a80,80,0,0,1,80,80h0a80,80,0,0,1-80,80h0a80,80,0,0,1-80-80h0A80,80,0,0,1,96,16.23Z",
    transform: "translate(-0.02 -0.23)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174.23h0a80.23,80.23,0,0,1-80-79v1h0a80.25,80.25,0,0,0,80,80h0a80.24,80.24,0,0,0,80-80h0v-1A80.23,80.23,0,0,1,96,174.23Z",
    transform: "translate(-0.02 -0.23)",
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  }))))))), /*#__PURE__*/React.createElement("circle", {
    cx: 128.69,
    cy: 96,
    r: 21.81,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.26,
    cy: 96,
    r: 21.81,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.05
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.26,
    y1: 117.81,
    x2: 128.69,
    y2: 117.81,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.05
  }));
}

var _default = ic_voicemail;
exports.default = _default;